import type { BoxProps } from "@mantine/core";
import { Box } from "@mantine/core";
import _ from "lodash";

import { Decimal } from "prisma/cm/client/runtime/library";

import { RangeBar, RangeBarWithFixedSize } from "./RangeBar";

type ExplorerRangeBarProps = BoxProps & {
  lowValue?: number | Decimal | null;
  highValue?: number | Decimal | null;
};

export function ExplorerRangeBar(props: ExplorerRangeBarProps) {
  function renderInside() {
    if (_.isNil(props.lowValue) || _.isNil(props.highValue)) {
      return <RangeBar empty />;
    } else {
      return <RangeBarWithFixedSize lowValue={props.lowValue} highValue={props.highValue} />;
    }
  }

  return (
    <Box
      ml="auto"
      display={{ base: "none", sm: "flex" }}
      {..._.omit(props, ["lowValue", "highValue"])}
    >
      {renderInside()}
    </Box>
  );
}
